import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createFeatureSelector, createReducer, on } from '@ngrx/store';
import * as CityActions from './city.actions';
import { City } from './city.model';

export const citiesFeatureKey = 'cities';

export interface State extends EntityState<City> {
    // additional entities state properties
}

export const adapter: EntityAdapter<City> = createEntityAdapter<City>({
    selectId: (model: City) => model.id,
    sortComparer: (a, b) => a.City.localeCompare(b.City)
});

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

const cityReducer = createReducer(
    initialState,
    on(CityActions.addCity, (state, action) =>
        adapter.addOne(action.city, state)
    ),
    on(CityActions.upsertCity, (state, action) =>
        adapter.upsertOne(action.city, state)
    ),
    on(CityActions.addCitys, (state, action) =>
        adapter.addMany(action.citys, state)
    ),
    on(CityActions.upsertCitys, (state, action) =>
        adapter.upsertMany(action.citys, state)
    ),
    on(CityActions.updateCity, (state, action) =>
        adapter.updateOne(action.city, state)
    ),
    on(CityActions.updateCitys, (state, action) =>
        adapter.updateMany(action.citys, state)
    ),
    on(CityActions.deleteCity, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(CityActions.deleteCitys, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(CityActions.loadCitys, (state, action) =>
        adapter.setAll(action.citys, state)
    ),
    on(CityActions.clearCitys, state => adapter.removeAll(state))
);

export function reducer(state: State | undefined, action: Action) {
    return cityReducer(state, action);
}
const localState = createFeatureSelector<State>(citiesFeatureKey);
export const { selectIds, selectEntities, selectAll, selectTotal } =
    adapter.getSelectors(localState);
